import MaterialTable from "@material-table/core";
import { Box } from "@material-ui/core";
import { ReportService } from "../../../services/SubmissionService";
export default function DailyUploadsWidget() {
    return (
        <Box sx={{ width: "100%" }}>
            <MaterialTable
                columns={[
                    { title: "Filename", field: "filename" },
                    {
                        title: "Uploaded By",
                        field: "uploadedBy",
                    },
                    {
                        title: "Total Documents",
                        field: "totalDocuments",
                    },
                    {
                        title: "Uploaded",
                        field: "uploadedDateTime",
                    },
                ]}
                data={(query) =>
                    new Promise((resolve, reject) => {
                        ReportService.getUploadsToday({
                            pageNumber: query.page + 1,
                            itemsPerPage: query.pageSize,
                        }).then(
                            (resp) => {
                                resolve({
                                    data: resp.data as any,
                                    page: (resp.currentPage ?? 1) - 1,
                                    totalCount: resp.totalCount ?? 0,
                                });
                            },
                            (error) => {
                                console.log(error);
                                //setError(error);
                            }
                        );
                    })
                }
                title="Uploads Today"
            />
        </Box>
    );
}
